module.exports = __webpack_public_path__ + "img/helpbox-4.a7cd4bfc.png";